import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10986d40")

_pushScopeId("data-v-10986d40")
const _hoisted_1 = { class: "platform__title" }
const _hoisted_2 = { class: "platform__content" }
const _hoisted_3 = { class: "platform__description" }
const _hoisted_4 = { class: "btn-text" }
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = { class: "" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ms_store_badge = _resolveComponent("ms-store-badge")

  return (_ctx.GlobalStore.isWindowsOs)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: ["platform", { active: _ctx.isActive }]
      }, [
        _createVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t('platformWindows.title')), 1),
        _withDirectives(_createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('platformWindows.description')), 1),
          _createVNode("a", {
            href: _ctx.appData.fallbackLink,
            class: "platform__btn btn btn--primary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addToApps && _ctx.addToApps(...args)))
          }, [
            _createVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('platformWindows.addToApps')), 1)
          ], 8, ["href"]),
          _createVNode("div", {
            style: {display: `${_ctx.showInstall ? 'block' : 'none'}`},
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.copyAppUrl && _ctx.copyAppUrl(...args)))
          }, [
            _hoisted_5,
            _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('platformWindows.notInstalledYet')), 1),
            _hoisted_7,
            _hoisted_8,
            _createVNode(_component_ms_store_badge, {
              productid: "9N4KL7JFS0V9",
              "window-mode": "full",
              theme: "auto",
              language: "en"
            })
          ], 4)
        ], 512), [
          [_vShow, _ctx.isActive]
        ])
      ], 2))
    : _createCommentVNode("", true)
})